import { useEffect, useState } from "react"
import { Card, CardContent, Grid, Typography, List, ListItem, ListItemText, ListItemIcon } from "@mui/material"
import PropTypes from 'prop-types'
import { ResponsiveContainer, BarChart, Bar, Cell, Tooltip, XAxis } from "recharts"
import SentimentVeryDissatisfiedOutlinedIcon from '@mui/icons-material/SentimentVeryDissatisfiedOutlined';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';

import { capitalize, colors, crafts } from "../../utils"

const DeckChart = ({ gameData }) => {
    const [chartData, setChartData] = useState(null)
    const [notes, setNotes] = useState(null)

    const sortClass = (chartList) => {
        const deckAcc = {}
        crafts.forEach((craft) => {
            deckAcc[craft] = []
            const re = new RegExp(craft, 'i')

            chartList.forEach((item) => {
                if (re.test(item.name)) deckAcc[craft].push(item)
            })
        })
        return deckAcc
    }

    const setWinsLosses = (record, val) => {
        if ((record) === 'WIN') val.wins++
        if ((record) === 'LOSE') val.losses++
    }

    const makeChartData = () => {
        const reducedData = gameData.reduce((acc, curr) => {
            const deckIndex = acc.map(item => item.name).indexOf(curr.opponent)

            if (deckIndex === -1) {
                const newDeck = { name: curr.opponent, wins: 0, losses: 0 }
                setWinsLosses(curr.result, newDeck)
                return [...acc, newDeck]
            }

            setWinsLosses(curr.result, acc[deckIndex])
            return acc
        }, [])

        setChartData(sortClass(reducedData))
        return reducedData
    }

    useEffect(() => {
        makeChartData()
        setNotes(null)
    }, [gameData])

    const handleDeckClick = (data) => {
        const filterNotes = gameData.filter(val => val.opponent === data.name && val.notes !== '')
        setNotes(filterNotes)
    }

    return (
        <Card sx={{ mb: 3 }}>
            <CardContent>
                <Typography variant='h5' sx={{ mb: 2 }}>"{gameData[0].deck}" Deck Stats</Typography>
                <Grid container>
                    <Grid item xs={12}>
                        <Grid container>
                            {chartData && (
                                Object.entries(chartData).map((craftDecks) => (
                                    <Grid item xs={6} md={3} key={craftDecks[0]}>
                                        <ResponsiveContainer width='100%' height={150}>
                                            <BarChart margin={{ left: 20 }} data={craftDecks[1]}>
                                                <Tooltip />
                                                <XAxis type='category' dataKey='name' label={capitalize(craftDecks[0])} tick={false} />
                                                <Bar dataKey='wins' stackId='a' onClick={handleDeckClick}>
                                                    {craftDecks[1].map((entry) => <Cell cursor='pointer' key={`${entry.name}-win`} fill={colors[craftDecks[0]][0]} />)}
                                                </Bar>
                                                <Bar dataKey='losses' stackId='a' onClick={handleDeckClick}>
                                                    {craftDecks[1].map((entry) => <Cell cursor='pointer' key={`${entry.name}-lose`} fill={colors[craftDecks[0]][1]} />)}
                                                </Bar>
                                            </BarChart>
                                        </ResponsiveContainer>
                                    </Grid>
                                ))
                            )}
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant='h6' align='center' sx={{ mb: 1 }}>Notes</Typography>
                        {notes && (
                            notes.length > 0 ? (
                                <List sx={{ marginLeft: 1 }}>
                                    {notes.map((note) => (
                                        <ListItem key={note.id} divider sx={{ bgcolor: note.result === 'LOSE' && '#e0e0e0' }}>
                                            {note.result === 'WIN' && <ListItemIcon><ThumbUpIcon /></ListItemIcon>}
                                            {note.result === 'LOSE' && <ListItemIcon><ThumbDownIcon /></ListItemIcon>}
                                            <ListItemText>
                                                {note.notes}
                                            </ListItemText>
                                        </ListItem>
                                    ))}
                                </List>
                            ) : (
                                <Typography align='center'>
                                    Sorry, no notes... <SentimentVeryDissatisfiedOutlinedIcon />
                                </Typography>
                            )
                        )}

                        {!notes && <Typography align='center'>Please click a deck to see notes.</Typography>}
                    </Grid>
                </Grid>
            </CardContent>
        </Card >
    )
}

DeckChart.propTypes = {
    gameData: PropTypes.array.isRequired
}

export default DeckChart